import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { Tone } from "./tones.model";



export const tonesStore = createStore({ name: "tones" }, withEntities<Tone>(), withRequestsStatus());
